import React from 'react'

const CollectorContext = React.createContext(null)

export const Provider = CollectorContext.Provider
export const Consumer = CollectorContext.Consumer

export default CollectorContext
